import React from "react";
import "../../../tenantComponent/common/header/header.css"; 
import OrganizationNameHeader from "../../../components/common/OrganizationNameHeader/OrganizationNameHeader";
import { useTheme } from "../../../utils/context/ThemeContext";
import { Moon, Sun } from "lucide-react";

interface ContractorHeaderProps {
  OrgDetail?: any;
}

const ContractorHeader: React.FC<ContractorHeaderProps> = ({
  OrgDetail,
}) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <>
      <header className="tenant-header">
        <OrganizationNameHeader
          OrgName={OrgDetail?.name || "Organization Name"}
          OrgImg={
            OrgDetail?.logoImageBase64 && OrgDetail?.logoImageBase64 !== ""
              ? `data:image/*;base64,${OrgDetail?.logoImageBase64}`
              : null
          }
          SubHeaderName={""}
          element={
            <>
              <div className="onboardtopbar__right d-flex align-items-center gap-2">
                <button
                  onClick={toggleTheme}
                  className="onboardtopbar__chat-btn"
                  title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                >
                  {theme === "light" ? <Moon size={20} color="#667085" /> : <Sun size={20} color="#f9fafb" />}
                </button>
              </div>
            </>
          }
        />
      </header>
    </>
  );
};

export default ContractorHeader;
